<template>
  <v-dialog v-model="isDeleteDialog" max-width="400">
    <template v-slot:activator="{ attrs }">
      <v-row no-gutters class="container-btn">
        <v-tooltip top color="#131b1e">
          <template v-slot:activator="{ on }">
            <v-btn
              dark
              block
              plain
              color="#eee"
              v-bind="attrs"
              v-on="on"
              @click="openDialog"
              class="btn-control"
              elevation="0"
            >
              <span
                class="material-icons-round mr-1"
                style="color: #ddd; font-size: 18px; font-weight: 400"
                translate="no"
              >
                delete
              </span>
              Delete
            </v-btn>
          </template>
          <span>Delete this clip</span>
        </v-tooltip>
      </v-row>
      <!-- <v-icon v-bind="attrs" v-on="on" style="font-size: 40px" color="white">mdi-delete</v-icon> -->
    </template>
    <v-card class="container-clip-delete px-5 py-3" color="#21343b" width="auto">
      <v-row no-gutters align="center" justify="center">
        <v-col class="px-5 mt-2" :cols="12" align="start" justify="start">
          <span class="delete-clip-title">{{ $t('deleteCurrentClip') }}</span>
        </v-col>
        <v-col class="px-5 mt-2" :cols="12" align="start" justify="center">
          <span class="delete-clip-content">{{ $t('remindContent') }}</span>
        </v-col>

        <v-row class="container-btn my-4 mx-5" no-gutters align="start" justify="center">
          <v-col class="mr-5">
            <v-btn
              :loading="isDeleteClipLoading"
              :disabled="isDeleteClipLoading"
              dark
              block
              height="40"
              elevation="0"
              color="#ff575f"
              @click="deleteClip"
            >
              {{ $t('delete') }}
            </v-btn>
          </v-col>
          <v-col>
            <v-btn dark block height="40" elevation="0" color="#869399" @click="isDeleteDialog = false">
              {{ $t('cancel') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import Toast from '@/views/meeting/component/Toast'
import { deleteClip } from '@/services/clipApi'
import { mapGetters } from 'vuex'

export default {
  name: 'ClipDeleteDialog',
  data() {
    return {
      isDeleteDialog: false,
      isDeleteClipLoading: false,
    }
  },
  methods: {
    openDialog() {
      this.setForceStop()
      this.$emit('expandMenu', false)
      this.isDeleteDialog = true
    },
    // 클립 삭제
    async deleteClip() {
      if (this.currentClip.clipDuration && this.currentClip.clipDuration <= 0) {
        // notify(this, 'Error', this.$t('alreadyDeleted'), 'error')
        const content = {
          component: Toast,
          props: {
            msg: this.$t('alreadyDeleted'),
            // submsg: '',
          },
        }
        this.$toast.error(content)
      } else if (!this.currentClip || this.currentClip === undefined || this.currentClip === null) {
        // notify(this, 'Error', this.$t('noClipToDelete'), 'error')
        const content = {
          component: Toast,
          props: {
            msg: this.$t('noClipToDelete'),
            // submsg: '',
          },
        }
        this.$toast.error(content)
      } else {
        try {
          let stId = this.totalSectionList[this.sectionIndex].stId
          this.isDeleteClipLoading = true
          await deleteClip(this, 'CLIP', this.mtInfo.wsId, this.mtInfo.mtId, stId, this.currentClip.clipId)

          // 클립 삭제되었을 시 workspace 의 총 클립 갯수를 새롭게 업데이트 시켜준다.
          this.$store.dispatch('setWsClipCnt', {
            wsDomain: this.$route.params['wsDomain'],
            userId: this.userInfo ? this.userInfo['userId'] : null,
          })
          // notify(this, 'Success', this.$t('deleteClipSuccess'), 'success')
          const content = {
            component: Toast,
            props: {
              msg: this.$t('deleteClipSuccess'),
              // submsg: '',
            },
          }
          this.$toast.success(content)
          localStorage.setItem('stId', stId)

          this.$store.dispatch('getAssignedCnt', this.mtInfo.wsId)
          this.$store.dispatch('getChannelUpdate', {
            wsId: this.mtInfo['wsId'],
            chId: this.selectedCh['chId'].includes('CH:') ? this.selectedCh['chId'] : `CH:${this.selectedCh['chId']}`,
            chType: this.selectedCh['chType'],
            chCategory: this.selectedCh['chCategory'],
          })
        } catch (error) {
          // notify(this, 'Error', this.$t('general.seriousError'), 'error')
          const content = {
            component: Toast,
            props: {
              msg: this.$t('general.seriousError'),
              // submsg: '',
            },
          }
          this.$toast.error(content)
        } finally {
          // delete 후 영상재생 안되도록 변경
          this.$store.dispatch('setIsPauseSeek', true)
          // 클립 삭제 후 전체로딩 없이 리스트 다시 만들어주는 작업 추가
          this.$store.dispatch('setDeleteClip', this.currentClip.clipId)
          // this.$emit('refreshData')
          this.isDeleteClipLoading = false
          this.isDeleteDialog = false
        }
      }
    },
    setForceStop() {
      this.$store.dispatch('setIsPlayerForceStop', !this.$store.getters.isPlayerForceStop)
    },
  },
  computed: {
    ...mapGetters(['selectedCh', 'userInfo']),
    currentClip() {
      return this.$store.getters.currentClip
    },
    totalSectionList() {
      return this.$store.getters.totalSectionList
    },
    sectionIndex() {
      return this.$store.getters.sectionIndex
    },
    mtInfo() {
      return this.$store.getters.currentMt
    },
    isPlayerPause() {
      return this.$store.getters.isPlayerPause
    },
  },
  watch: {
    isDeleteDialog(val) {
      if (val) this.setForceStop()
    },
  },
}
</script>

<style scoped>
.v-dialog__content >>> .v-dialog {
  overflow: hidden;
}
.container-clip-delete {
  border-radius: 10px;
}
.delete-clip-title {
  font-weight: bold;
  font-size: 20px;
  color: white;
}
.delete-clip-content {
  font-size: 14px;
  color: #96a7af;
}
/* .container-btn >>> .v-btn * {
  font-size: 13px;
  color: white;
  letter-spacing: 0;
  text-transform: none;
  font-weight: 500;
} */
/* .container-btn .btn-control {
  width: 35px;
  height: 35px;
  background-color: transparent;
  min-width: 35px !important;
} */
@media (max-width: 959px) {
  .container-btn .btn-control {
    background-color: transparent !important;
  }
}
.v-tooltip {
  z-index: 200;
}
.v-tooltip__content {
  font-size: 12px !important;
  opacity: 1;
}
/* .v-btn {
  transition: all 0.3s;
  border: 1px solid transparent;
}
.v-btn:hover {
  border: 1px solid rgba(10, 14, 16, 1);
  background-color: rgb(33, 52, 59);
  transition: all 0.3s;
} */
</style>
